import { render } from "./StrategyConfig.vue?vue&type=template&id=70e78c30"
import script from "./StrategyConfig.vue?vue&type=script&lang=js"
export * from "./StrategyConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__